<app-upsell-card
  htmlTitle="Softer Stools, <strong>Less Pain</strong>"
  question="We strongly recommend including a stool softener in your prescription. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    Straining during bowel movements is a major cause of hemorrhoid pain, swelling, and irritation.
    <strong>
      Adding stool softener capsules to your treatment plan can help make bowel movements easier and more comfortable,
    </strong>
    reducing pressure that can worsen symptoms.
  </p>
  <p class="mb-4">
    By gently softening stool, these capsules support smoother passage, promote healing, and help lower the risk of
    flare-ups during recovery.
  </p>
  <p class="mb-4">
    If you're looking for more comfortable, less painful bowel movements while your hemorrhoids heal,
    <strong>adding a daily stool softener can make a noticeable difference</strong>.
  </p>
</app-upsell-card>
